/* Copyright (c) 2018 Scaper */

import { APP_PATH } from "../appPath";

export const PROFILE_PATH = `${APP_PATH}/profile`;
